<template>
  <form>
    <text-input
      :value="value"
      @input="emitTyping"
      placeholder="Search"
      classes="is-rounded has-addons"
      :label="false">
      <template #right>
        <div class="buttons has-addons is-rounded">
          <submit-button
            :working="searching"
            @submit="runSearch"
            class="is-rounded">
            Search
          </submit-button>
          <action-button
            class="is-rounded"
            v-if="value.length"
            @click="clearSearch">
            <icon icon="backspace" />
          </action-button>
          <slot name="buttons"/>
        </div>
      </template>
    </text-input>
  </form>
</template>

<script>
export default {

  props: {
    value: {
      type: String,
      default: '',
    },
    searching: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    emitTyping(value) {
      this.$emit('input', value)
    },

    clearSearch() {
      this.$emit('clear-search')
    },

    runSearch() {
      this.$emit('run-search')
    },
  },

}
</script>
